var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { setTargetDocument } from "../../Connections/actions/actions";
import SearchForm from "../../Connections/components/SearchForm";
import SearchResults from "../../Connections/components/SearchResults";
import { Icon } from "../../UI";
import { sortByStrings } from "../../../shared/data_utils/objectSorting";
import {
  deleteRelationships,
  getRelationshipsByEntity,
  saveRelationship } from "../actions/V2NewRelationshipsActions";


const bg = (i) => i % 2 === 0 ? '#f2f2f2' : '#ffffff';

class V2NewRelationshipsBoard extends Component {
  constructor(props, context) {
    super(props, context);
    this.relationships = [];
    this.newEntryType = this.props.relationTypes[0]._id;
    this.entityTitlesBySharedId = {};
  }

  async componentDidMount() {
    const relationships = await getRelationshipsByEntity(this.props.sharedId);

    const [fromThis, toThis] = _.partition(
      relationships,
      (r) => r.from.entity === this.props.sharedId
    );
    sortByStrings(fromThis, [
    (r) => r.from.entityTitle,
    (r) => r.relationshipTypeName,
    (r) => r.to.entityTitle]
    );
    sortByStrings(toThis, [
    (r) => r.from.entityTitle,
    (r) => r.relationshipTypeName,
    (r) => r.to.entityTitle]
    );
    this.relationships = [...fromThis, ...toThis];
    this.forceUpdate();
  }

  selectType(event) {
    this.newEntryType = event.target.value;
  }

  appendTargetTitleToMap() {
    const { targetDocument } = this.props;
    const searchResults = this.props.searchResults.toJS();
    const savedResult = searchResults.find((r) => r.sharedId === targetDocument);
    this.entityTitlesBySharedId[targetDocument] = savedResult.title;
  }

  async saveRelationship() {
    const { sharedId, targetDocument } = this.props;
    const [saved] = await saveRelationship(this.newEntryType, sharedId, targetDocument);
    this.appendTargetTitleToMap();
    this.relationships.push(saved);
    this.forceUpdate();
  }

  deleteRelationship(id) {
    return async () => {
      await deleteRelationships([id]);
      this.relationships = this.relationships.filter((r) => r._id !== id);
      this.forceUpdate();
    };
  }

  showReferenceText(relationship, i) {
    if (relationship.from.text || relationship.to.text) {
      return (/*#__PURE__*/
        _jsx("tr", { style: { height: '100px', background: bg(i) } }, void 0, /*#__PURE__*/
        _jsx("td", { style: { padding: '5px' } }, void 0, relationship.from.text), /*#__PURE__*/
        _jsx("td", { colSpan: "5", style: { padding: '5px' } }, void 0,
        relationship.to.text
        )
        ));

    }
  }

  render() {
    const { searchResults, uiState, relationTypes, targetDocument } = this.props;

    return (/*#__PURE__*/
      _jsx("div", { className: "v2_new_rel_board", "no-translate": true }, void 0, /*#__PURE__*/
      _jsx("div", {}, void 0, "Existing:"), /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("table", { style: { width: '100%' } }, void 0, /*#__PURE__*/
      _jsx("tr", {}, void 0, /*#__PURE__*/
      _jsx("th", { style: { width: '30%' } }, void 0, "From"), /*#__PURE__*/
      _jsx("th", {}), /*#__PURE__*/
      _jsx("th", {}, void 0, "Relationship Type"), /*#__PURE__*/
      _jsx("th", {}), /*#__PURE__*/
      _jsx("th", { style: { width: '30%' } }, void 0, "To"), /*#__PURE__*/
      _jsx("th", {}, void 0, "Delete")
      ),
      this.relationships.map((r, i) => /*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx("tr", { style: { height: '40px', background: bg(i) } }, void 0, /*#__PURE__*/
      _jsx("td", { style: { padding: '5px 8px' } }, void 0,
      r.from.entityTitle,
      ` (${r.from.entityTemplateName})`
      ), /*#__PURE__*/
      _jsx("td", {}, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "arrow-right" })
      ), /*#__PURE__*/
      _jsx("td", { style: { padding: '5px 8px' } }, void 0, r.relationshipTypeName), /*#__PURE__*/
      _jsx("td", {}, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "arrow-right" })
      ), /*#__PURE__*/
      _jsx("td", { style: { padding: '5px 8px' } }, void 0,
      r.to.entityTitle,
      ` (${r.to.entityTemplateName})`
      ), /*#__PURE__*/
      _jsx("td", {}, void 0, /*#__PURE__*/
      _jsx("button", { type: "button", onClick: this.deleteRelationship(r._id).bind(this) }, void 0, "X"

      )
      )
      ),
      this.showReferenceText(r, i)
      )
      )
      )
      ), /*#__PURE__*/
      _jsx("br", {}), /*#__PURE__*/
      _jsx("div", {}, void 0, "Add new:"), /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("select", {
        name: "newEntryTypeSelector",
        id: "newEntryTypeSelector",
        onChange: this.selectType.bind(this) }, void 0,

      relationTypes.map((rt) => /*#__PURE__*/
      _jsx("option", { value: rt._id }, void 0, rt.name)
      )
      ), "\u2003", /*#__PURE__*/

      _jsx(Icon, { icon: "arrow-right" }), "\u2003", /*#__PURE__*/

      _jsx("input", {
        type: "text",
        id: "newEntryTargetSelector",
        name: "newEntryTargetSelector",
        value: targetDocument || 'select target entity',
        disabled: true }
      ), "\u2003", /*#__PURE__*/

      _jsx("button", {
        type: "button",
        disabled: !targetDocument,
        onClick: this.saveRelationship.bind(this) }, void 0,
      "Save"

      ), /*#__PURE__*/
      _jsx(SearchForm, {}), /*#__PURE__*/
      _jsx(SearchResults, {
        results: searchResults,
        searching: uiState.get('searching'),
        selected: targetDocument,
        onClick: this.props.setTargetDocument }
      )
      )
      ));

  }
}

V2NewRelationshipsBoard.defaultProps = {};










function mapStateToProps(state) {
  return {
    relationTypes: state.relationTypes.toJS(),
    uiState: state.connections.uiState,
    searchResults: state.connections.searchResults,
    targetDocument: state.connections.connection.get('targetDocument')
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setTargetDocument }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(V2NewRelationshipsBoard);
export { mapStateToProps, mapDispatchToProps };